import React from 'react';
import { withStyles } from '@material-ui/core/styles';

import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Fields from 'ui/form/FieldsForm';
import ConfirmationDialog from 'ui/dialog/ConfirmationDialog';

import {
    Table,
    TableBody,
    TableRow,
    TableCell,
    TableHead,
} from '@material-ui/core';

const selectOwnerStyles = theme => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
        width: '100%',
        paddingBottom: '30px',
    },
    right: {
        float: 'right',
    },
});

class SelectOwner extends React.Component {
    state = {
        changeOwnerMode: false,
        showChangeOwnerConfirmation: false,
    };

    handleChangeMode = () => {
        this.setState({ showChangeOwnerConfirmation: true });

        if (this.props.recipientsInfo.length > 0) {
            this.props.onChange(this.props.recipientsInfo[0].name);
        }
    };

    renderInputComponent = inputProps => {
        const { classes, inputRef = () => {}, ref, ...other } = inputProps;

        return (
            <>
                <TextField
                    label="Enter new owner name"
                    margin="normal"
                    variant="outlined"
                    fullWidth
                    InputProps={{
                        inputRef: node => {
                            ref(node);
                            inputRef(node);
                        },
                    }}
                    {...other}
                />
            </>
        );
    };

    showChangeOwner = (initialValue, recipientsInfo, onChange, editable) => {
        if (this.state.changeOwnerMode || initialValue) {
            let options = recipientsInfo.reduce((options, item) => {
                options[item.name] = item.name;
                return options;
            }, {});

            const noRecipients = Object.keys(options).length === 0;

            options = noRecipients ? { empty: 'Nothing selected' } : options;

            return (
                <Fields.Select
                    disabled={noRecipients}
                    value={initialValue || 'empty'}
                    onChange={onChange}
                    options={options}
                />
            );
        } else {
            return (
                <Button
                    disabled={!editable}
                    variant="outlined"
                    onClick={() => this.handleChangeMode()}
                >
                    Change owner
                </Button>
            );
        }
    };

    render() {
        const {
            classes,
            shareInfo,
            recipientsInfo,
            transferInProgress,
            newOwner,
            onChange,
            editable,
        } = this.props;

        return (
            <div className={classes.container}>
                <ConfirmationDialog
                    open={this.state.showChangeOwnerConfirmation}
                    title="Change share owner"
                    subtitle1="When a share owner is changed, the current owner will change to an Editor and the selected user will be the new Owner."
                    onCancel={() =>
                        this.setState({ showChangeOwnerConfirmation: false })
                    }
                    onOk={() => {
                        this.setState({
                            showChangeOwnerConfirmation: false,
                            changeOwnerMode: true,
                        });
                    }}
                />
                <Table>
                    {/* <TableHead>
                        <TableRow>
                            <TableCell
                                style={{
                                    width: '60%',
                                    fontWeight: 'bold',
                                }}
                            >
                                Owner
                            </TableCell>
                            <TableCell
                                style={{
                                    width: '35%',
                                }}
                            />
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell align="left">
                                {shareInfo.owner}
                            </TableCell>
                            <TableCell aligh="right">
                                <div className={classes.right}>
                                    {transferInProgress ? (
                                        <Typography>
                                            Transfer in progress
                                        </Typography>
                                    ) : (
                                        this.showChangeOwner(
                                            newOwner,
                                            recipientsInfo,
                                            onChange,
                                            editable
                                        )
                                    )}
                                </div>
                            </TableCell>
                        </TableRow>
                    </TableBody> */}
                </Table>
            </div>
        );
    }
}
export default withStyles(selectOwnerStyles)(SelectOwner);
